import React from 'react';
import MUTypography from '../../../../../ui/MUTypography';
import CodeBlock from '@tenon-io/tenon-codeblock';
import './styles.css';
import sample from './Texts.js';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const Info11 = (props) =>
  <div>
    <MUTypography variant='h4' className={props.classes.h4}>
      Signing
    </MUTypography>
    <br/>
    <MUTypography variant='h5' className={props.classes.h5}>
      Signing Requests
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      To invoke private APIs in the production environment, your requests must be signed using RSA encryption.<br></br>
      <br></br>
      RSA (Rivest-Shamir-Adleman) is an asymmetric cryptographic algorithm that utilizes a dual-key system: a Public Key and a Private Key.<br></br>
      <br></br>
      RSA Key size should be 1024 bit. Once you generate your public-private key pair, you must share the Public Key with us. The Private Key must be stored securely and used for the signing step.
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      You can also generate a public-private key pair by registering at the <a href='https://developer.albarakaturk.com.tr/register' style={{fontWeight: 'bold'}}>Albaraka Api Market</a> and creating a new application. For detailed instructions on membership and creating a test application, you can refer to the following guide:
      <br></br>
      <a href='https://medium.com/albaraka-open-banking/registering-on-albaraka-api-market-and-creating-a-test-application-305a6a303cc1' target='_blank' rel='noreferrer' style={{fontWeight: 'bold'}}>
        Registering on Albaraka API Market and Creating a Test Application | by Albaraka Open Banking | Albaraka Open Banking | Medium
      </a>
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      Fields must be sign with private key as shown below and signature should be placed in header with 'sign' key.
    </MUTypography>
    <br/>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      POST : token data and body
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      GET : token data and query string
    </MUTypography>
    <MUTypography variant='h6' className={props.classes.h6}>
      Sample Public Key
    </MUTypography>
    <div style={{ width: 710 }}>
      <CodeBlock
        language="text"
        codeString={'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwfVYqHn95yl5npU0QdjSlZ0Dpjy9kjGKHLHyQTCpQIEQzpbiXywWgaIFkToEcGuibSase++7TTeU+NZyEkyvnzWBi4EUZ7sbHApi+Lt+p1iduPVl8tYFEfOC8ATUTctRFOxQIruvVPGI7D43H1Yyz5xW6TsJBRleRXNj2iRuqWDaGbY88rvRZQi86BlzNjjgssAeOvYqb/O6NZJCuePLkP2dUE84YmKyhfkbgOa6ygIhxdAIhgDpt4yy48fzs0WVIKjkRJAc0oM9UwadQUAFo8OpEZHpO9KQcOe1KYbi395L5b+YrmdctlPFqFq3/D8sQKs4n8c2TTXTuEjpUYsINwIDAWED'}
      />
    </div>
    <br/>
    <MUTypography variant='h6' className={props.classes.h6}>
      Sample Private Key
    </MUTypography>
    <div style={{ width: 710 }}>
      <CodeBlock
        language="text"
        codeString={'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDB9Vioef3nKXmelTRB2NKVnQOmPL2SMYocsfJBMKlAgRDOluJfLBaBogWROgRwa6JtJqx777tNN5T41nISTK+fNYGLgRRnuxscCmL4u36nWJ249UngZgUR84LwBNTBcZEU7FAiu69U8YjsPjcfVjLPnFbpOwkFGV5Fc2PaJG6pYNoZtjzyu9FlCLzoGXM2OOCywB469ipv87o1kkK548uQ/Z1QTzhiYrKF+RuA5rrKAiHF0AiGAOm3jLLjx/OzRZUgqOREkBzSgz1TBp1BQAWjw6kRkek70pBw57UphuLf3k/lT5iuZ1y2U8WoWrf8PyxAqzifxzZNNdO4SOlRiwg3AgMBAAECggEAEKpC/t7UeQswPvb08X9uwJooGR148Fm/Uy3a8cz7jeZJCmcediz0lhjUv6CrhvlIkHZVNaTog/71ltfeH0JliJlxUwo5NZx2/NbLoDGD9V8A1kaFHXnGj79LjdHscd6PJ6wSSpmzu+mw6RODavbeEMaPFSUUZlLCrdb3SmP8+iKI3AsOISP/Lp3WbnixxUk17G5HyDezDmpEOrxvz1Zt2iqgww+BDtkcVl7mr/ZOkLJJmWVUJjfNPKnYMv5le6gUxJDL4Oy70rCJDuRXzfvDgCJQy/ssPq5MJvUJIDL3cdAHawepJnaSpGJCpJ0Fu1C1JVTg7+GHpTu6IRbqzwxH6QKBgQDthXqnAbgLuHsqPrFgBn0djuislTdtkZG8v3fMpXU9yLP77puOOKp5G8BSw5UBEs3mYzu16ZCrdzWitOpGU0zFwH0OI983XUcuuA/M2qt3umJGCiONzcikbXM2g4h/MpmYbjl/kIzDILuQcmo/K1Z4dcyVGuRnCAEtJUfKcB1eMwKBgQDRDEIIlttLtyUY/V7KIQEg8higrbl/QvoUJaZTLL5VBJg9D0+7g4ApEmwzINZQ4PIGY9sJqgi0QEp577yar/Xhk6ecZyFWO0DjNu2ZVKRmF05XVOaYcoPQloShU2JJdHbOVIf5SYK3Rf5zukAymkEOi5WotnbnJiNEeWgkvzDL6hKBgQCx1mfgFURk2iq1lZ0e5ZzV/cMuPMb0bbKtnLoo6pVeviAseBnWIY1aAjI8hZ3R4O9zGUeCy677AtWQzl4+a24m/hlj9e3SOS/rxfpmii8qBM5B3KOEL9iTbDOAVHllq1AfNiAs5+DM1Hw7Cb+NLnie1qxn02vBzNd8otYet1T1ywKBgQCqkqjy3z0Su97OVDdbELEeE8yalwYr3Be4Brx/U5v+PSCHeg3iADu7x6d31IxrNBDnu+THLvGpOmhKtJ4dTgSASn3SNahS90hL3c7jdNgr4UpwIfuCWrZJpfeUtzgUna4vT3Qfqaa6KqekAE5Pu+PnnWfBYRkGJO1T+whKK6MURQKBgBabYVTyzX8wgxbV0uAtKLHmxW2G0fGU8INmP2aelgCgX6MNU8dN9PFcIlao40oM33Ji3aA56Nsu1zYHc2TfMRBGNi3tG0uTVbjJnUZdNUxF8PsJfxSRB2TSSG3g2BZ6Styrl54a8sy9cC549RvSu638Ht7et4JPD1/d4AcasDEK'}
      />
    </div>
    <br/>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      To generate a valid signature using the sample code provided below, follow these instructions:
      <br></br>
      1. Insert your Private Key.<br></br>
      2. Add the Token generated from the authorization services.<br></br>
      3. Add the Request Body of the API you intend to call.
    </MUTypography>
    <MUTypography variant='h6' className={props.classes.h6}>
      Sample Signing Method
    </MUTypography>
    <div className="demo">
      <Tabs forceRenderTabPanel defaultIndex={1}>
        <TabList>
          <Tab style={{fontSize:20}}>Java</Tab>
          <Tab style={{fontSize:20}}>C#</Tab>
        </TabList>
        <TabPanel>
          <CodeBlock language="html" codeString={sample['java']} />
        </TabPanel>
        <TabPanel>
          <CodeBlock language="html" codeString={sample['csharp']} />
        </TabPanel>
      </Tabs>
    </div>
    <br/>
    <MUTypography variant='h6' className={props.classes.h6}>
      Sample Sign Value
    </MUTypography>
    <div style={{ width: 710 }}>
      <CodeBlock
        language="text"
        codeString={'VL4ZoinIiOdfLjORRA4C1jU9a0+rSh3mX0Q/Vr1nLz9Zztd2JGbC3/JWAJhDRnP8tZiG/6abwFfRl+c+CJFSJU6K2Om+REPA0ojC0vYv9NF2p+pvSvmrqkkXsm6+bnYjQ9vPMEAi/R3Aws45UI6U/lbkGvvjzVlP2eIR0Ap6jIbMWvjwDSRQnNY4rWh9KSTCdBsxal8hFN7pcHnZ8dxoaiP7H/9WErNWSSprRwseUnj8tRYZEfupjtSSSLXdjoz8JXL73oiIwMl/p3SOL128dHThzpFmgUfgEJ55uR24cH+eEy6qarbB/Pc5PRMnQY8scNKx1CB4/4kHGOB1oo0Lew=='}
      />
    </div>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      The signature value should be included in the request header with the key 'sign'.
    </MUTypography>
    <br/>
    <MUTypography variant='h5' className={props.classes.h5}>
      Signing Response
    </MUTypography>
    <br/>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      In api calls, you can sign the responses.<br></br>
      If you want to sign service responses, you must pass "isResponseSigned : true" in the request header when making service requests.<br></br>
      You can get the signed response information from the "signedResponse" field in the response header.
      And if you want to get the decrypted version of the signed data, you can parse the signature with the public key below.<br></br>
      The response is signed with SHA256withRSA and the public key is in RSA PKCS8 format.<br></br>
    </MUTypography>
    <br></br>
    <div style={{ width: 710 }}>
      <CodeBlock language="html" codeString={sample['signResponsePublicKey']} />
    </div>
    <br/>
    <MUTypography variant='h5' className={props.classes.h5}>
      IP Filter
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      IP Filter is applied to all api calls. Filtering operation checks if the request is made from IP which is specified while creating application. The request made from unknown ip is responded with "Invalid IP" error message.
    </MUTypography>
    <br/>
    <MUTypography variant='h5' className={props.classes.h5}>
      Rate Limiter
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      In api calls there are limitations to 5 request per seconds and 100 request per day for a client. In case of over use 'Too many requests' error message is thrown.
    </MUTypography>
    <br/>
  </div>;

export default Info11;
